var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-invert)",
    d: "M0 0h1600v900H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-primary)",
    fillOpacity: 0.12,
    d: "M0 0h1600v900H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-primary)",
    fillOpacity: 0.12,
    d: "M405.198-31.21h168.208l48.826-209.047c24.162-103.448-40.112-206.897-143.56-231.059-103.448-24.162-206.897 40.113-231.058 143.561L178.505-31.871H10.513l-66.439 287.529h168.791L-416 2544.44h394.838L507.702 255.658h81.869L429.696 935.904c-24.305 103.416 39.826 206.956 143.24 231.256 103.415 24.31 206.952-39.83 231.257-143.24l163.823-697.038c5.657-24.073 16.468-71.239 16.468-71.239H851.867l10.345-39.895C888.877 112.917 827.132 7.94 724.3-18.725 621.469-45.39 516.491 16.355 489.827 119.187l-35.384 136.456H338.916l66.282-286.852ZM1437.28 602.057h168.21l48.83-209.048c24.16-103.448-40.12-206.896-143.56-231.058-103.45-24.162-206.9 40.112-231.06 143.56l-69.11 295.884H1042.6l-66.442 287.529h168.792L616.083 3177.71h394.837l528.87-2288.786h81.86l-159.87 680.246c-24.31 103.41 39.83 206.95 143.24 231.26 103.41 24.3 206.95-39.83 231.26-143.24l163.82-697.042c5.66-24.073 16.47-71.238 16.47-71.238h-132.62l10.35-39.895c26.66-102.832-35.08-207.809-137.92-234.474-102.83-26.665-207.81 35.081-234.47 137.912l-35.38 136.457H1371l66.28-286.853Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCover);
export default __webpack_public_path__ + "static/media/defaultCover.6e4d41735ab3eda5ed7103fcde0e8157.svg";
export { ForwardRef as ReactComponent };